export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";